/**
 * Feature flags whose enabled-state we want stamped onto every Google Analytics
 * event as the `enabled_flags` attribute.
 */
type TrackedFlags = Record<string, () => boolean>;

const TRACKED_FLAGS: TrackedFlags = {};

/**
 * Comma-joined names of the tracked feature flags that are currently enabled,
 * or `undefined` when none are.
 */
export function getEnabledTrackedFlags(trackedFlags: TrackedFlags = TRACKED_FLAGS): string | undefined {
    const enabled = Object.entries(trackedFlags)
        .filter(([, isEnabled]) => isEnabled())
        .map(([name]) => name);

    return enabled.length > 0 ? enabled.join(',') : undefined;
}
